module.exports = __webpack_public_path__ + "mm.386487d6.svg";